
import {Fragment} from "react";
import fetchIntercept from "fetch-intercept";
import {interceptor} from "./utils/Interceptor.utils";

import AppRoutes from "./routes/AppRoutes";

function App() {
    fetchIntercept.register(interceptor);
  return (
   <Fragment>
     <AppRoutes/>
   </Fragment>
  );
}

export default App;
